import styled from 'styled-components';
import { EllipsisIcon, PenIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/base-components';

export const StyledRow = styled(Text).attrs({
  size: 'small',
  color: 'primaryText',
})`
  display: table-row;
  &:nth-of-type(2n + 1) {
    background-color: ${({ theme }) => theme.colors.foreground};
  }
`;

export const StyledCell = styled(Box).attrs(
  ({ padding }: { padding: string }) => ({
    size: 'small',
    padding: padding || '8px 16px',
  }),
)`
  border-top: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
  vertical-align: middle;
  display: table-cell;
`;

export const StyledNameCell = styled(StyledCell)`
  min-width: 100px;
`;

export const StyledActionCell = styled(StyledCell)`
  max-width: 32px;
  text-align: center;
  padding: 0 5px;
`;

export const StyledWordsCell = styled(StyledCell)`
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledEditIcon = styled(PenIcon).attrs({ width: 12, height: 12 })`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.secondaryLink};
  &:hover {
    color: ${({ theme }) => theme.colors.primaryText};
  }
`;

export const StyledMenuIcon = styled(EllipsisIcon).attrs({
  width: 12,
  height: 12,
})`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.secondaryLink};
  &:hover {
    color: ${({ theme }) => theme.colors.primaryText};
  }
`;
